export const ifoodConstants = {
    IFOOD_MERCHANTS_SUCCESS: 'IFOOD_MERCHANTS_SUCCESS',
    IFOOD_MERCHANTS_ERROR: 'IFOOD_MERCHANTS_ERROR',
    IFOOD_MERCHANTS_REQUEST: 'IFOOD_MERCHANTS_REQUEST',
    IFOOD_MERCHANTS_RESET: 'IFOOD_MERCHANTS_RESET',
    IFOOD_ORDERS_REQUEST: 'IFOOD_ORDERS_REQUEST',
    IFOOD_ORDERS_SUCCESS: 'IFOOD_ORDERS_SUCCESS',
};
